import { Combinations } from '../../components/combinations';
import { LiveBets } from '../../components/liveBets';
import { LiveBetsWr } from '../../components/liveBetsWr';

export function GameLeftInner() {
  return (
    <div className='tb-left-inner'>
      <div className='tb-left-combinations-wrp'>
        <Combinations />
        <LiveBetsWr InnerComp={LiveBets} />
      </div>
    </div>
  );
}
